import { render, staticRenderFns } from "./LeaderboardAccuracyTotalTradesRenderer.vue?vue&type=template&id=0d2d25e8&"
import script from "./LeaderboardAccuracyTotalTradesRenderer.vue?vue&type=script&lang=js&"
export * from "./LeaderboardAccuracyTotalTradesRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports